import React from 'react';
import Layout from '../../Components/Layout';
import ProductDetails from '../../Components/ProductDetails';

const SingleProduct = () => {
    
    return (
        <Layout>
            <ProductDetails/>
        </Layout>
    );
};

export default SingleProduct;